import React, {useEffect, useState} from 'react';
import './team.css';

interface TeamMember {
	id: string, 
	name: string, 
	bio: string,
	imgUrl: string,
}

const Team: React.FC = () => {
	const [activeModal, setActiveModal] = useState<string | null>(null);
	const teamMembers: TeamMember[] = [
		{
			id: 'gabe-modal', 
			name: 'S. Gabe Hatch, PhD', 
			bio: `Dr. S. Gabe Hatch, Ph.D., is a licensed clinical psychologist with PSYPACT authorization and quantitative expertise, currently completing advanced training in clinical psychopharmacology. He has authored more than 30 peer-reviewed publications, including work in PLOS Mental Health, Journal of Consulting and Clinical Psychology, and Journal of Personality and Social Psychology. His research has also been featured in The New York Times, Forbes, and Psychology Today. \n\nDr. Hatch’s research focuses on how technology—particularly generative AI and scalable digital tools—can enhance the delivery of evidence-based psychotherapy for individuals and couples who are underserved, high-risk, or otherwise difficult to reach. His work bridges clinical science, machine learning, and systems-level innovation, with a strong emphasis on open, transparent, and reproducible research practices. He is committed to building tools and publishing work that can be easily accessed, evaluated, and improved by the broader scientific and clinical communities.`,
			imgUrl: "/assets/static/gabe_2.png"
		},
		{
			id: 'zach-modal', 
			name: 'Zachary T. Goodman, PhD', 
			bio: 'Dr. Zachary T. Goodman, Ph.D., is a clinical psychologist specializing in neuropsychological assessment, neuroimaging analytics, Bayesian statistics, and psychometrics. He has authored approximately 40 peer-reviewed publications across a broad range of topics in psychological science, with particular emphasis on cognitive aging and dementia, multimodal neuroimaging, and data-driven approaches to assessing cognition and psychopathology. His work has appeared in leading journals such as Nature Mental Health, Journal of Alzheimer’s Disease, Cerebral Cortex, and Psychometrika.\n\nDr. Goodman’s research focuses on advancing empirically grounded practices in clinical psychology and neuropsychology by integrating methodological innovations and statistical rigor. He actively collaborates with multidisciplinary research teams, serving as a statistical consultant on projects that span clinical neuroscience, digital mental health, and quantitative psychology. ',
			imgUrl: "/assets/static/goodman_2.jpeg"
		},
		{
			id: 'bryar-modal', 
			name: 'N. Bryar Topham',
			bio: 'Bryar is a researcher, full-stack developer, and Head of Technological Development at Hatch Data and Mental Health. He specializes in building and training generative AI models, designing scalable data systems, and utilizing open-source technologies to benefit the psychology research community.',
			imgUrl: "/assets/static/bryar.jpeg"
		},
		// {id: 'john-modal', name: 'John', bio: 'TODO', imgUrl:"https://placehold.co/240x240.avif"} // TODO once I get a bio and photo from john
	];

	const openModal = (id:string) => {
		setActiveModal(id);
		document.body.style.overflow = 'hidden';
	};

	const closeModal = () => {
		setActiveModal(null);
		document.body.style.overflow = 'auto';
	};

	const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target instanceof HTMLDivElement && e.target.className == 'modal') {
			closeModal();
		}
	};

	return (
		<div className="team-wrapper">
			<span className='team-span'>Meet the Team</span>
			<div className='bio-cards-carousel'>
				{teamMembers.map(member => (
					<div key={member.id} className='bio-card' onClick={() =>openModal(member.id)}>
						<img src={member.imgUrl} alt={member.name}/>
						<span className='bio-span'>{member.name}</span>
						<div className='card-overlay'>View Bio</div>
					</div>
				))}
			</div>
      <svg className="wave" viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path d="M0,0 C480,100 960,0 1440,100 L1440,0 L0,0 Z" fill="var(--color6)" />
      </svg>
		
			{/* Modals */}
			{teamMembers.map(member => (
				<div
					key={member.id} 
					id={member.id} 
					className='modal' 
					style={{display: activeModal == member.id ? 'flex' : 'none'}} 
					onClick={handleModalClick}
				>
					<div className='modal-content'>
						<span className='close-modal' onClick={closeModal}>&times;</span>
						<h2>{member.name}</h2>
						<p>{member.bio}</p>
					</div>
				</div>
			))}
		</div>
	)
}

export default Team

// TODO
// get updated bios and pictures from team

